import {memo} from 'react';

import type {SVGProps} from 'react';

export const HandBoxIcon = memo(function HandBoxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M57.5759 37.4763L57.6453 37.4043C57.6333 37.415 57.6226 37.423 57.6106 37.4336C57.5986 37.447 57.5906 37.463 57.5759 37.4763Z"
          fill="var(--icon-fill-yellow)"
        />
        <path
          d="M62.8454 37.1561C61.3014 35.6121 59.244 35.6801 57.2574 37.1561C55.2707 38.6334 44.0201 47.0361 44.0201 47.0361L43.9921 47.0374C44.9414 46.3161 45.5641 45.1854 45.5641 43.9014C45.5641 41.7187 43.7947 39.9507 41.6134 39.9507H35.8267C28.1947 39.9507 28.0054 38.6334 23.6054 38.6334C17.4361 38.6334 13.0547 44.5401 11.1174 47.7761C10.4001 48.9747 10.4801 50.4827 11.3094 51.6067L16.2307 58.2814C17.4574 59.9454 19.8641 60.1841 21.3734 58.7707C22.3787 57.8294 23.8081 57.0707 25.8081 57.0707C31.1454 57.0707 36.4641 58.3881 41.6121 58.3881C45.3321 58.3881 48.5307 54.7547 62.88 42.7001C64.384 41.1547 64.3747 38.6867 62.8454 37.1561Z"
          fill="var(--icon-fill-yellow)"
        />
        <path
          d="M35.7732 8.6665H45.9999C48.2092 8.6665 49.9999 10.4572 49.9999 12.6665V32.6665"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={4}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3333 32.6665V12.6665C19.3333 10.4572 21.1239 8.6665 23.3333 8.6665H24.1133"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={4}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.3333 16.6665H37.9999"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={4}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.3039 39.2266C56.2252 38.4439 57.1999 37.6212 58.2319 36.7546L58.1612 36.8279C59.7239 35.2652 59.7239 32.7332 58.1612 31.1706C56.5985 29.6079 54.5159 29.6759 52.5039 31.1706C50.4932 32.6666 39.1025 41.1732 39.1025 41.1732"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={4}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.3334 41.9998H36.6668C38.8761 41.9998 40.6668 40.2092 40.6668 37.9998C40.6668 35.7905 38.8761 33.9998 36.6668 33.9998H30.8094C23.0828 33.9998 22.8908 32.6665 18.4361 32.6665C12.2534 32.6665 7.84544 38.5252 5.85477 41.8212C5.08677 43.0932 5.1761 44.6998 6.05744 45.8945L10.8561 52.4038C12.1601 54.1718 14.6748 54.3798 16.3201 52.9252C17.3294 52.0332 18.7361 51.3345 20.6668 51.3345C26.0708 51.3345 31.4548 52.6678 36.6668 52.6678C39.2614 52.6678 41.6054 50.9225 47.5654 45.8425"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={4}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
